import React from 'react';
import styled from 'styled-components';
import LightButton from '~/editor/buttons/LightButton';

import DoneIcon from '~/assets/icons/done2.svg';
import XIcon from '~/assets/icons/x.svg';

export const DoneBtnIcon = styled(DoneIcon)``;
export const XBtnIcon = styled(XIcon)``;

const Wrapper = styled.div`
  display: flex;

  button {
    padding: 5px;
    width: 38px;
    height: 38px;

    svg {
      margin-left: 7px;
    }

    &.active svg {
      path {
        fill: #fff;
      }
    }
    &:disabled {
      cursor: not-allowed;
      background-color: #a9a9a9 !important;
      svg {
        path {
          fill: #d4d4d4 !important;
        }
      }
    }
    &:disabled.active {
      background-color: #6f6f6f !important;
    }
  }

  button:first-child {
    border-radius: 5px 0 0 5px;
  }

  button:last-child {
    border-radius: 0 5px 5px 0;
  }
`;

export const Switcher = ({
  value,
  onChange,
  disabled
}: {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}) => {
  return (
    <Wrapper>
      <LightButton
        className={value === 'true' ? 'active' : ''}
        onClick={() => onChange('true')}
        disabled={disabled}
      >
        <DoneBtnIcon />
      </LightButton>
      <LightButton
        className={value === 'false' ? 'active' : ''}
        onClick={() => onChange('false')}
        disabled={disabled}
      >
        <XBtnIcon />
      </LightButton>
    </Wrapper>
  );
};
